export default {
	btnAdd: 'Valider',
	delete: 'Supprimer',
	edit: 'Modifier',
	numAM: 'Numéro AM',
	firstname: 'Prénom',
	lastname: 'Nom',
	placeholderSearchActor: 'N°AM ou n°FINESS Géographique',
	ruleMessage: 'Vous devez valider l\'acteur'
};
